<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13 16.0002V5.41436L16.2929 8.70726L17.7071 7.29304L12 1.58594L6.29289 7.29304L7.70711 8.70726L11 5.41436V16.0002H13ZM21 20.0002V11.0002H19V20.0002H5V11.0002H3V20.0002C3 21.1047 3.89543 22.0002 5 22.0002H19C20.1046 22.0002 21 21.1047 21 20.0002Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'DownloadIcon',

  props: {
    fill: {
      default: '#474B6D',
      type: String,
    },
  },
};
</script>